import {
  Component,
  OnInit,
  Input,
  ViewChild,
} from "@angular/core";
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { SectionResource } from '../../core/modules/openapi';

@Component({
  exportAs: "innerSection",
  imports: [MatExpansionModule, DynamicFormComponent, MatIconModule, MatTooltipModule, CommonModule],
  selector: "inner-section",
  template: `
    <mat-expansion-panel class="innerSection">
      <mat-expansion-panel-header class="innerSectionPanelHeader">
        <mat-panel-title>
          <div [innerHTML]="section.title"></div>&nbsp;
          <mat-icon class="iconeInfo" color="primary" matTooltip="{{section.tooltipValue}}"
                    [matTooltipClass]="{ 'tool-tip': true }" matTooltipPosition="above"
                    *ngIf="section.tooltipValue">
            info
          </mat-icon>
          &nbsp;
        </mat-panel-title>
        <mat-panel-description *ngIf="!valid">
          &nbsp;<mat-icon *ngIf="!valid" class="iconeWarning">warning</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <dynamic-form [fields]="section.fields" [form]="form"
                    *ngIf="section.fields.length>0"></dynamic-form>
    </mat-expansion-panel>
  `,
  standalone: true,
  styleUrls: ['./inner-section.component.css']
})
export class InnerSectionComponent implements OnInit {
  @Input() section: SectionResource;
  //@Input() parentForm: String;
  @Input() form: FormGroup;
  @Input() sequence: Number;
  valid: Boolean = true;

  @ViewChild(DynamicFormComponent, { static: false }) dynamicForm: DynamicFormComponent;

  ngOnInit() {
    this.form = this.createFormGroup();
  }

  createFormGroup() {
    return new FormGroup([new FormControl('', Validators.required)]);
  }
}
